/* eslint-disable */

import * as originPackageService from "../../services/originPackage";
import * as settings from "../../services/settings";

import { Button, Col, Input, InputNumber, Row, Spin, Table, Typography, Upload, notification } from "antd";
import React, { useCallback, useEffect, useState } from "react";

import dayjs from "dayjs";
import { formatNumber } from "../model/formatNumber";
import permissions from "../../../configs/permission";
import { useAccessToken } from "../../contexts/AccessTokenContext";
import { usePermission } from "../../hooks/usePermission";

// import { ModalDelete } from "../model/modal/delete";
// import { ModalCreateOriginPackageServices } from "./model/ModalCreateOriginPackageServices";

const { TextArea } = Input;
const { Title } = Typography;
const { Dragger } = Upload;

const initPage = { limit: 10, page: 1, total: 1 };
let promiseAwait;
export const CreateOriginPackageServices = ({ t, type, detailData }) => {
  const { hasPermission, isSuperuser } = usePermission();
  const { accessToken } = useAccessToken();
  const [search, setSearch] = useState(initPage);
  const [originPackageServicesData, setOriginPackageServicesData] = useState([]);
  // const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCreate, setIsCreate] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [prepareDeleteData, setPrepareDeleteData] = useState({});
  const [editedData, setEditedData] = useState([]);

  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, message, description) => {
    api[type]({
      message: message,
      description: description,
    });
  };

  // const showModal = () => {
  //   setIsModalOpen(true);
  // };
  // const handleOk = () => {
  //   setIsModalOpen(false);
  // };
  // const handleCancel = () => {
  //   setIsModalOpen(false);
  // };

  const handleChangeServiceCost = (value, index) => {
    const newData = [...originPackageServicesData];
    newData[index].service_cost = value;
    setOriginPackageServicesData(newData);
  };

  const handleChangeNote = (value, index) => {
    const newData = [...originPackageServicesData];
    newData[index].note = value;
    setOriginPackageServicesData(newData);
  };

  const fetchOriginPackageServices = useCallback(
    async (param) => {
      if (!detailData?.id) return;
      setLoading(true);
      const params = { ...param };
      let updateById = detailData.id;
      try {
        const raw = await originPackageService.getOriginPackageService(accessToken, updateById, params);
        // OT เก็บในฐานข้อมูลสำหรับ billing/transport แต่ไม่แสดงหรือแก้ในหน้านี้
        const data = (raw ?? []).filter((item) => item.package_service !== "OT");
        // Service ที่ต้องมีครบทุกตัว
        const requiredServices = ["OD", "WC", "IN"];
        // ตรวจสอบว่าขาด service ไหนบ้าง
        const existingServices = data.map((item) => item.package_service);
        const missingServices = requiredServices.filter((service) => !existingServices.includes(service));
        // สร้าง dummy ข้อมูลสำหรับ service ที่ขาด
        const missingData = missingServices.map((service) => ({
          id: `new-${service}`, // ใส่ id ชั่วคราวไม่ซ้ำ
          package_service: service,
          note: "",
          service_cost: 0,
          origin_package_id: detailData.id, // ใช้ id ตัวเดียวกัน
        }));
        // รวมข้อมูลเดิม + ข้อมูลที่เติม
        const fullData = [...data, ...missingData];
        // เรียงตามลำดับ Origin Delivery > Wooden Create > Insurance
        const serviceOrder = ["OD", "WC", "IN"];
        const sortedData = fullData.sort((a, b) => {
          return serviceOrder.indexOf(a.package_service) - serviceOrder.indexOf(b.package_service);
        });
        if (data.length === 0) {
          setIsCreate(true);
        }
        setOriginPackageServicesData(sortedData);
        setEditedData(sortedData);
        setSearch({ ...param });
      } catch (err) {
        console.error("[CreateOriginPackageServices] fetchOriginPackageServices: ", err);
        const { message } = settings.getErrorMessage(err);
        openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
        setLoading(false);
      }
      setLoading(false);
    },
    [accessToken, detailData.id]
  );

  const handleSave = async () => {
    setLoading(true);
    try {
      if (isCreate) {
        await originPackageService.createOriginPackageService(accessToken, editedData);
      } else {
        await originPackageService.updateOriginPackageService(accessToken, editedData);
      }
      setIsCreate(false);
      openNotificationWithIcon(settings.NotificationType.SUCCESS, <>{"Success."}</>, <>{"Save data success"}</>);
      fetchOriginPackageServices(); // reload ใหม่
    } catch (err) {
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
      console.error("[CreateOriginPackageServices] handleSave: ", err);
      setLoading(false);
    }
    setLoading(false);
  };

  const onDeleteOriginPackageService = async (data) => {
    let prepareData = {
      id: data.id,
    };
    setLoading(true);
    try {
      const response = await originPackageService.deleteOriginPackageService(accessToken, prepareData);
      openNotificationWithIcon(settings.NotificationType.SUCCESS, <>{"Success."}</>, <>{"Delete sale success"}</>);
      setPrepareDeleteData({});
      setIsOpenDelete(false);
      fetchOriginPackageServices();
      setLoading(false);
    } catch (err) {
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
      console.error("[CreateOriginPackageServices] onDeleteOriginPackageService: ", err);
      setLoading(false);
    }
  };

  const getTotalServiceCost = () => {
    return originPackageServicesData.reduce((total, item) => {
      const cost = parseFloat(item.service_cost) || 0;
      return total + cost;
    }, 0);
  };

  useEffect(() => {
    if (!accessToken || !detailData?.id) return;
    fetchOriginPackageServices();
  }, [accessToken, fetchOriginPackageServices, detailData?.id]);

  const columns = [
    {
      title: () => {
        return <>{t("Origin_Package_Create.Create_Services.Table_Package_Service")}</>;
      },
      with: 150,
      dataIndex: "package_service",
      key: "package_service",
      render: (_, record) => {
        if (record.package_service === "OD") {
          return <p>{t("Origin_Package_Create.Create_Services.Table_OriginDelivery")}</p>;
        } else if (record.package_service === "WC") {
          return <p>{t("Origin_Package_Create.Create_Services.Table_WoodenCreate")}</p>;
        } else if (record.package_service === "IN") {
          return <p>{t("Origin_Package_Create.Create_Services.Table_Insurance")}</p>;
        }
      },
    },
    {
      title: () => {
        return <>{t("Origin_Package_Create.Create_Services.Table_Service_Cost")}</>;
      },
      with: 150,
      dataIndex: "service_cost",
      key: "service_cost",
      render: (_, record, index) => {
        return (
          <InputNumber
            min={0}
            value={record.service_cost}
            onChange={(value) => handleChangeServiceCost(value, index)}
          />
        );
      },
    },
    {
      title: () => {
        return <>{t("Origin_Package_Create.Create_Services.Table_Service_Cost_CNY")}</>;
      },
      with: 150,
      dataIndex: "note",
      key: "note",
      render: (_, record, index) => {
        return <TextArea value={record.note} onChange={(e) => handleChangeNote(e.target.value, index)} autoSize />;
      },
    },
    {
      title: () => {
        return <>{t("Package_Table.Table_Created_At")}</>;
      },
      with: 150,
      dataIndex: "created_at",
      key: "created_at",
      render: (_, record) => {
        const created_at = record.created_at != null ? dayjs(record.created_at).format("YYYY-MM-DD HH:mm:ss") : "-";
        return <p>{created_at}</p>;
      },
    },
    {
      title: () => {
        return <>{t("Package_Table.Table_Updated_At")}</>;
      },
      with: 150,
      dataIndex: "updated_at",
      key: "updated_at",
      render: (_, record) => {
        const updated_at = record.updated_at != null ? dayjs(record.updated_at).format("YYYY-MM-DD HH:mm:ss") : "-";
        return <p>{updated_at}</p>;
      },
    },
  ];

  return (
    <>
      {contextHolder}
      <Spin spinning={loading}>
        <Row align="middle" justify="end">
          <Col span={24}>
            <Table
              columns={columns}
              dataSource={originPackageServicesData}
              scroll={{ x: "1440px", y: "500px" }}
              rowKey={(record) => record.id}
              pagination={{
                defaultPageSize: search.limit,
                current: search.page,
                pageSize: search.limit,
                total: search.total,
                onChange: (page, limit) => {
                  fetchCompany({ ...search, page, limit });
                },
                showSizeChanger: true,
              }}
              style={{ cursor: "pointer" }}
              summary={() => (
                <Table.Summary.Row>
                  <Table.Summary.Cell index={0} colSpan={1}>
                    <b>Total</b>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={1} colSpan={1}>
                    <b>{formatNumber(getTotalServiceCost())}</b>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={2} colSpan={2} />
                </Table.Summary.Row>
              )}
            />
          </Col>
          {hasPermission(permissions.OriginPackageService.ADD) && (
            <Row justify="end" style={{ marginTop: "10px" }}>
              <Col span={24}>
                <Button type="primary" onClick={handleSave} style={{ marginRight: "10px", justifyContent: "end" }}>
                  {t("Button_Packages.BTN_Add_Service")}
                </Button>
              </Col>
            </Row>
          )}
          {/* <ModalCreateOriginPackageServices
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            handleOk={handleOk}
            handleCancel={handleCancel}
            detailData={detailData}
            editOriginPackageServiceData={editOriginPackageServiceData}
            fetchOriginPackageServices={fetchOriginPackageServices}
            isEdit={isEdit}
            t={t}
          />
          <ModalDelete
            isOpen={isOpenDelete}
            handleCloseModal={() => {
              setIsOpenDelete(false);
            }}
            onClick={() => {
              onDeleteOriginPackageService(prepareDeleteData);
            }}
            dataDetail={prepareDeleteData}
            t={t}
          /> */}
        </Row>
      </Spin>
    </>
  );
};
